import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import ButtonBase from "components/shared/ButtonBase";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { renderHello } from "helpers/utils";
import type { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

interface AuthLoginProps {
    username: string;
    email: string;
    showPassword: boolean;
    error: boolean;
    errorMessage: string;
    isReadyToConnect: boolean;
    isLoading: boolean;
    handleEmail: (e: any) => void;
    handlePassword: (e: any) => void;
    handleClickShowPassword: () => void;
    handleLogin: () => void;
    handleSAMLLogin: () => void;
    handleForgetPassword: () => void;
}

const AuthLogin = ({
    username,
    email,
    showPassword,
    error,
    errorMessage,
    isReadyToConnect,
    isLoading,
    handleEmail,
    handlePassword,
    handleClickShowPassword,
    handleLogin,
    handleSAMLLogin,
    handleForgetPassword,
}: AuthLoginProps) => {
    const [t] = useTranslation();

    const handleLoginFromPwdField = (e: KeyboardEvent<HTMLInputElement>) =>
        e.key == "Enter" && isReadyToConnect && handleLogin();

    return (
        <>
            {(username == "" && <h1>{t("LogIn.LogIn")}</h1>) || (
                <h1 className="trans-slide-in">
                    {t(renderHello())} {username}
                </h1>
            )}
            <div className="login-left-container-fields trans-slide-in" key={"login"}>
                <div className="login-left-container-field">
                    <div className="login-left-container-subtext">{t("LogIn.Email")}</div>
                    <StyledTextField
                        placeholder="email@crealo.app"
                        value={email}
                        onChange={handleEmail}
                        onKeyDown={handleLoginFromPwdField}
                    />
                </div>
                <div className="login-left-container-field">
                    <div className="login-left-container-subtext">{t("LogIn.Password")}</div>
                    <StyledTextField
                        placeholder="•••••••••••••"
                        type={showPassword ? "text" : "password"}
                        onChange={handlePassword}
                        onKeyDown={handleLoginFromPwdField}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleClickShowPassword} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className="login-left-container-otherField">
                    {/* <div className="login-left-container-otherField-rememberMe login-left-container-subtext">
                        <StyledCheckbox id="remme" />
                        <label htmlFor="remme">{t("LogIn.RememberMe")}</label>
                    </div> */}
                    <div></div>
                    <div
                        className="login-left-container-otherField-forgotPassword login-left-container-subtext"
                        onClick={handleForgetPassword}
                    >
                        {t("LogIn.ForgotPassword")}
                    </div>
                </div>
                <ButtonBase
                    variant="contained"
                    styles={{ borderRadius: "4px" }}
                    disabled={!isReadyToConnect}
                    loading={isLoading}
                    onClick={handleLogin}
                >
                    {t("LogIn.LogIn")}
                </ButtonBase>
                {/* ou
                <ButtonBase
                    variant="contained"
                    styles={{ borderRadius: "4px" }}
                    loading={isLoading}
                    onClick={handleSAMLLogin}
                >
                    Connexion via SAML SSO
                </ButtonBase> */}
                {error && <div className="login-left-container-error">{errorMessage || t("LogIn.Error")}</div>}
            </div>
        </>
    );
};

export default AuthLogin;
